export default __webpack_public_path__ + "static/media/2ccfe469da54d9b5.21179e42e0e3748cf8e566515c1578b7.svg";